<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text px-10"
        block
        v-on="on"
      >
        Create
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Payroll Cycles"
      text="Create payroll cycle"
      class="mb-0"
      :loading="loading"
    > 
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="code"
                v-validate="'required'" 
                label="Code"
                :error-messages="errors.collect('code')"
                data-vv-name="code"    
                data-vv-as="code" 
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="name"
                v-validate="'required'" 
                label="Name"
                :error-messages="errors.collect('name')"
                data-vv-name="name"    
                data-vv-as="name" 
              />
            </v-col>

            <v-col cols="12">
              <tiptap-vuetify
                v-model="description"
                class="full-width text-editor-toolbar-height pb-1"
                placeholder="Description"
                :extensions="extensions"
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <span>Include Additional Deduction (TP1)? </span>
              <v-radio-group
                v-model="isIncludeTP1"
                class="mt-0"
                row
              >
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
                <v-radio
                  label="No"
                  :value="0"
                />
              </v-radio-group>
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <span>Include Basic Salary? </span>
              <v-radio-group
                v-model="isIncludeBasicSalary"
                class="mt-0"
                row
                @change="setDefaultValue"
              >
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
                <v-radio
                  label="No"
                  :value="0"
                />
              </v-radio-group>
            </v-col>

            <v-col
              v-if="isIncludeBasicSalary"
              cols="8"
              class="py-0"
            >
              <v-autocomplete
                v-model="startPeriod" 
                v-validate="'required'"
                label="Start Period"
                item-text="name"
                item-value="name"
                :error-messages="errors.collect('startPeriod')"    
                data-vv-name="startPeriod" 
                data-vv-as="start period"
                :items="timePeriods"
              />
            </v-col>

            <v-col
              v-if="isIncludeBasicSalary"
              cols="4"
              class="py-0"
            >
              <v-text-field
                v-model="startDay" 
                :rules="[rules.startDayRequired,rules.min,rules.max]"
                label="Start Day"
                type="number"
                :min="1"
                :max="31"
                @keydown.native="['e', 'E', '+', '-', '.'].includes($event.key) && $event.preventDefault()"
              />
            </v-col>

            <v-col
              v-if="isIncludeBasicSalary"
              cols="8"
              class="py-0"
            >
              <v-autocomplete
                v-model="endPeriod" 
                v-validate="'required'"
                :error-messages="errors.collect('endPeriod')"    
                data-vv-name="endPeriod" 
                data-vv-as="end period"
                label="End Period"
                item-text="name"
                item-value="name"
                :items="timePeriods"
              />
            </v-col>

            <v-col
              v-if="isIncludeBasicSalary"
              cols="4"
              class="py-0"
            >
              <v-text-field
                v-model="endDay" 
                :rules="[rules.endDayRequired,rules.min,rules.max]"
                label="End Day"
                type="number"
                :min="1"
                :max="31"
                @keydown.native="['e', 'E', '+', '-', '.'].includes($event.key) && $event.preventDefault()"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"           
          @click="submitForm"
        >
          Save
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { TiptapVuetify, Heading, Bold, Italic, Underline, BulletList, OrderedList, ListItem, Link, HardBreak } from 'tiptap-vuetify'

  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    components: {
      TiptapVuetify,
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        loading: false,
        code: null,
        description: null,
        name: null,
        // ignoreCycleFromBroughtForwardCalculation: 0,
        extensions: [
          Link,
          Underline,
          Italic,
          ListItem,
          BulletList,
          OrderedList,
          [Heading, {
            options: {
              levels: [1, 2, 3],
            },
          }],
          Bold,
          HardBreak,
        ],
        isIncludeBasicSalary: 0,
        isIncludeTP1: 0,
        timePeriods: [
          { name: 'current_month' }, 
          // { name: 'previous_month' },
        ],
        startPeriod: null,
        endPeriod: null,
        startDay: 1,
        endDay: 31,
        rules: {
          startDayRequired: value => !!value || 'The start day field is required',     
          endDayRequired: value => !!value || 'The end day field is required',     
          min: value => value >= 1 || 'Minimum number is 1',      
          max: value => value <= 31 || 'Maximum number is 31',      
        },  
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData() 
      },
    },

    methods: { 
      prepareFormData () {
        return {
          code: this.code,
          description: this.description,
          name: this.name,
          // ignore_cycle_from_brought_forward_calculation: this.ignoreCycleFromBroughtForwardCalculation,
          start_period: this.startPeriod,
          start_day: this.startDay,
          end_period: this.endPeriod,
          end_day: this.endDay,
          include_basic_salary: this.isIncludeBasicSalary,
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)
    
            this.$api.hrisPayrollCycles().create(this.prepareFormData())
              .then((response) => {
                if (response.status === 200 || response.status === 201) {
                  this.$emit('created')                
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false       
                }
              })
              .catch(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },

      setDefaultValue () {
        if (!this.isIncludeBasicSalary) {
          this.startPeriod = null
          this.startDay = null        
          this.endPeriod = null
          this.endDay = null
        }
      },
    },
  }
</script>

<style scoped>
.text-editor-toolbar-height>>> .v-toolbar__content{
  height: unset !important;
  min-height: 42px;
}
.text-editor-toolbar-height>>>.v-sheet.v-sheet--tile.theme--light.v-toolbar.v-toolbar--dense.v-toolbar--flat.grey.lighten-4{
  min-height:unset !important;
}
.full-width{
  width: 100%;
}
</style>
